export default __webpack_public_path__ + "e09ecc5b742326c140bce6ec28f990e5.svg";